import { useEffect } from "react";

function setMeta(name, content, attr = "name") {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  if (!href) return;
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Définit titre + description + balises Open Graph/Twitter uniques pour la page courante.
 * Les balises og:image sont injectées côté client : la couche de prérendu (robots sociaux
 * type facebookexternalhit) exécute le React et capture ces balises → aperçu correct par page.
 */
export function useSeo({ title, description, canonicalPath, image, type = "website", keywords } = {}) {
  useEffect(() => {
    const prev = document.title;
    if (title) document.title = title;
    if (keywords) setMeta("keywords", keywords);
    const origin = typeof window !== "undefined" ? window.location.origin : "";
    const url = canonicalPath ? `${origin}${canonicalPath}`
      : (typeof window !== "undefined" ? window.location.href : "");

    if (title) {
      setMeta("og:title", title, "property");
      setMeta("twitter:title", title);
    }
    if (description) {
      setMeta("description", description);
      setMeta("og:description", description, "property");
      setMeta("twitter:description", description);
    }
    setMeta("og:type", type, "property");
    if (url) setMeta("og:url", url, "property");

    if (image) {
      // Les aperçus sociaux (Facebook/WhatsApp) exigent une URL http absolue.
      // On refuse les images base64 (data:) et toute valeur non-URL : repli sur une image par défaut.
      let abs = "";
      if (image.startsWith("http")) abs = image;
      else if (image.startsWith("/")) abs = `${origin}${image}`;
      else abs = `${origin}/og-bons-plans.jpg`;
      setMeta("og:image", abs, "property");
      setMeta("og:image:secure_url", abs, "property");
      setMeta("twitter:image", abs);
      setMeta("twitter:card", "summary_large_image");
    }

    if (canonicalPath) setCanonical(url);
    return () => { document.title = prev; };
  }, [title, description, canonicalPath, image, type, keywords]);
}
